import JSZip from 'jszip'
import * as signalR from "@microsoft/signalr";
import CamposCalculados from '@/funcoes/CamposCalculados'
import sqllike from './SQLikeSource.js' //https://secretgeek.net/SQLike/index.html
import Query from 'devextreme/data/query';
import {markRaw} from 'vue'
import ServicesExecucaoRequisicaoAPI from '@/services/ServicesExecucaoRequisicaoAPI'
import {obterNomesTabelas, executarAlaSql, obterCamposTabela} from "@/services/ServicesExecucaoDataQuery";

class AuxTempo {
    constructor() {
        this.inicioDownload = null;
        this.inicioPreparacao = null;
        this.inicioTotal = null;
        this.pacotesEmDownload = [];
        this.pacotesEmPreparacao = [];
    }
}

class MetricasFonteDados {
    constructor() {
        this.dataInicioExecucao = Date.now();
        this.tempoFinalizacao = Date.now();
        this.tempoAteUltimoPronto = null;
        this.pacotes = [];
    }
}

class MetricasPacote {
    constructor(idPacote) {
        this.idPacote = idPacote
        this.dataInicioDownload = Date.now()
        this.dataInicioSerializacao = null;
        this.tempoDownload = null;
        this.tempoSerializacao = null;
    }
}

export class ExecucaoFontesDados {

    constructor(config) {
        this.parametrosExecucao = config.parametrosExecucao
        this.desenvolvimento = config.desenvolvimento
        this.progressoExecucao = config.progressoExecucao
        this.progressoDownload = config.progressoDownload
        this.fonteDadosConcluida = config.fonteDadosConcluida
        this.vue = config.vue;
        this.gravarParametros = config.gravarParametros;
        this.isExecucao = config.isExecucao
        this.reexecutaSeletores = config.reexecutaSeletores
        this.fontesDadosGeral = [];
        this.tempoTentando = 0
        this.painel = config.painel
        this.servicesExecucaoRequisicaoAPI = new ServicesExecucaoRequisicaoAPI(config.vue)
    }

    checkTipoCampo(value) {
        const re = /\d\d\d\d-\d\d-\d\d/

        if (value instanceof Date || re.exec(value) != null)
            return 'DATETIME'

        return this.vue.$vistra.Tipos.getTipoCampoByTipoJS(typeof value)
    }

    async compilaDataSetSqlQuery(fonteDados, fontesDados) {
        let dispositivo = this.vue.$store.getters.usuario.dispositivo;
        fonteDados.infoExecucao.utilizada = true
        if (!this.desenvolvimento) {
            fonteDados.infoExecucao.utilizada = !(
                (dispositivo.toUpperCase() == 'TABLET' && !fonteDados.executaTablet)
                || (dispositivo.toUpperCase() == 'MOBILE' && !fonteDados.executaMobile)
                || (dispositivo.toUpperCase() == 'DESKTOP' && !fonteDados.executaDesktop)
                || (dispositivo.toUpperCase() == 'WIDGET' && !fonteDados.executaWidget))
        }
        let startTime = performance.now()
        fonteDados.infoExecucao.executando = true
        fonteDados.auxTempo = new AuxTempo()
        fonteDados.auxTempo.inicioPreparacao = Date.now();
        try {
            if (fonteDados.infoExecucao.utilizada) {
                let nomesTabelas = await obterNomesTabelas(fonteDados.dataSetSqlQuery.query)

                let tabelasUtilizadas = []

                for (let item of nomesTabelas) {
                    let fd = fontesDados.find(fd => fd.aliasSqlQuery === item)
                    if (fd) {
                        tabelasUtilizadas.push(fd)
                    }
                }
                let fontesAindaExecutando = tabelasUtilizadas.find(tu => tu.infoExecucao.executando)

                //inclue fontes dependentes no objeto da fonte selecionada
                fonteDados.dataSetSqlQuery.idsFontesDadosDependentes = tabelasUtilizadas.map(tu => tu.id);

                let conjuntosUtilizados = tabelasUtilizadas.filter(fd => fd.tipo === 2);
                if (fontesAindaExecutando && conjuntosUtilizados.length > 0) {
                    conjuntosUtilizados.forEach((fd) => {
                        this.compilaDataSets(fd, fontesDados)
                    })
                } else if (fontesAindaExecutando) {
                    await this.compilaDataSetSqlQuery(fonteDados, fontesDados)
                }
            }

            let resultados = await executarAlaSql(fonteDados.dataSetSqlQuery.query, fontesDados)
            fonteDados.campos = obterCamposTabela(resultados, fonteDados)
            fonteDados.dados = resultados

            fonteDados.infoExecucao.tempoPreparacao = (Date.now() - fonteDados.auxTempo.inicioPreparacao)
            fonteDados.auxTempo.inicioPreparacao = null;

            this.calculaCamposFuncao(fonteDados)
            this.criaCamposClonados(fonteDados)

            fonteDados.ultimaAtualizacao = this.vue.$vistra.formatDate(new Date(), "yyyy-MM-dd'T'HH:mm:ss")

            this.setAsBaixado(fonteDados)

            if (this.progressoExecucao) {
                this.progressoExecucao();
            }
            if (this.progressoDownload) {
                this.progressoDownload();
            }
            if (this.fonteDadosConcluida) {
                this.fonteDadosConcluida(fonteDados.idUnico);
            }
        } catch (ex) {
            this.setAsBaixado(fonteDados)
            return false
        }
    }

    compilaDataSets(fonteDados, fontesDados) {
        let dispositivo = this.vue.$store.getters.usuario.dispositivo;
        fonteDados.infoExecucao.utilizada = true
        if (!this.desenvolvimento) {
            fonteDados.infoExecucao.utilizada = !(
                (dispositivo.toUpperCase() == 'TABLET' && !fonteDados.executaTablet)
                || (dispositivo.toUpperCase() == 'MOBILE' && !fonteDados.executaMobile)
                || (dispositivo.toUpperCase() == 'DESKTOP' && !fonteDados.executaDesktop)
                || (dispositivo.toUpperCase() == 'WIDGET' && !fonteDados.executaWidget))
        }
        let startTime = performance.now()
        fonteDados.infoExecucao.executando = true
        fonteDados.auxTempo = new AuxTempo()
        fonteDados.auxTempo.inicioPreparacao = Date.now();

        try {
            if (fonteDados.infoExecucao.utilizada) {
                let resultadosIndividuais = []
                const unico = fonteDados.dataSet.fonteDados.filter(fd => !!fd.id).length == 1
                fonteDados.dataSet.fonteDados.forEach((dsfd) => {
                    if (!!dsfd.id) {

                        let fdPai = fontesDados.find(f => f.id === dsfd.id)
                        if (!fdPai) {
                            //Se nao achar a fonte nas fontes recem executadas, buscar ela direto do painel
                            fdPai = this.painel.dadosPainel.fontesDados.find(f => f.id === dsfd.id)
                            if (!!fdPai) {
                                fontesDados.push(fdPai)
                            }
                        }

                        if (fdPai && (fdPai.tipo === 2 || fdPai.tipo === 3) && !fdPai.infoExecucao.status) {
                            // verifica se o a fonte pai ainda não foi executada
                            this.compilaDataSets(fdPai, fontesDados)
                        }
                        if (!!fdPai) {
                            let resultado = this.resolveDataSet({
                                dataSet: unico ? {
                                    ...dsfd,
                                    idFonteDados: fonteDados.id
                                } : dsfd, fontesDados: fontesDados, final: unico
                            })
                            resultadosIndividuais.push(resultado)

                        }
                    }
                })
                if (resultadosIndividuais.length > 1) {
                    let resultado = this.resolveDataSet({
                        dataSet: {...fonteDados.dataSet, idFonteDados: fonteDados.id},
                        fontesDados: resultadosIndividuais.concat(fontesDados),
                        final: true
                    })
                    if (resultado) {
                        fonteDados.campos = resultado.campos
                        fonteDados.dados = markRaw(resultado.dados)
                    }
                } else if (unico && resultadosIndividuais.length > 0) {
                    fonteDados.campos = resultadosIndividuais[0].campos
                    fonteDados.dados = markRaw(resultadosIndividuais[0].dados)
                }
                if (this.desenvolvimento && fonteDados.maximoLinhas > 0 && fonteDados.maximoLinhas < fonteDados?.dados?.length)
                    fonteDados.dados = fonteDados.dados.slice(0, fonteDados.maximoLinhas)
                else if (!this.desenvolvimento && fonteDados.maximoLinhasExec > 0 && fonteDados.maximoLinhasExec < fonteDados?.dados?.length)
                    fonteDados.dados = fonteDados.dados.slice(0, fonteDados.maximoLinhasExec)

                fonteDados.infoExecucao.tempoPreparacao = (Date.now() - fonteDados.auxTempo.inicioPreparacao)
                fonteDados.auxTempo.inicioPreparacao = null;

                this.calculaCamposFuncao(fonteDados)
                this.criaCamposClonados(fonteDados)

                fonteDados.ultimaAtualizacao = this.vue.$vistra.formatDate(new Date(), "yyyy-MM-dd'T'HH:mm:ss")
            }
            this.setAsBaixado(fonteDados)

            if (this.progressoExecucao) {
                this.progressoExecucao();
            }
            if (this.progressoDownload) {
                this.progressoDownload();
            }
            if (this.fonteDadosConcluida) {
                this.fonteDadosConcluida(fonteDados.idUnico);
            }

            console.stats(`Compilou conjunto de dados "${fonteDados.alias}" => ${performance.now() - startTime}`)
            return true;
        } catch (ex) {
            console.error(ex)
            this.vue.$vistra.showMessage(this.vue.$vistra.globalize("erro-ao-gerar-dados") + ": " + ex.message, "error");
            this.setAsBaixado(fonteDados)
            return false;
        }
    }

    resolveDataSet({dataSet, fontesDados, final}) {
        //fazer testes em http://secretgeek.net/SQLike/index.html
        let orderBy = [], groupBy = [], dadosF1 = [], dadosF2 = []

        const unico = !dataSet.hasOwnProperty("funcao"),
            isJoin = !unico && dataSet.funcao.includes('Join'),
            fazGroupByDepois = (dataSet.usaGroupBy && !unico)

        const getNomeCampo = function (campo) {
            if (unico && !final)
                return campo.toLowerCase()
            return ((unico || !isJoin) ? campo.replace("f1.", "").replace("f2.", "") : campo.toLowerCase().replace(".", "_")).toLowerCase()
        }

        const fillSelect = function (sel, renomearCampos, podeAgrupar) {
            let select = []
            sel.forEach(s => {
                let novoNome = getNomeCampo(s.campo)
                if (dataSet.usaGroupBy && podeAgrupar && s.funcao && s.funcao != 'agrupador') {
                    select.push(`|${s.funcao}|`)
                }
                select.push(novoNome.toLowerCase())
                if (renomearCampos) {
                    select.push('|as|')
                    if (!!s.novoNome && final)
                        novoNome = s.novoNome
                    select.push(novoNome.toLowerCase())
                }
            })
            return select
        }

        const processaCamposRelativos = function (arrayP, query) {

            let array = [...arrayP]
            array.forEach((element, index) => {
                if (Array.isArray(element))
                    return array[index] = processaCamposRelativos(element, query);
                if (index == 0 && element.match(new RegExp(`.*_relativo$`, 'g'))) {
                    element = getNomeCampo(element)
                    array[0] = element.substring(0, element.length - "_relativo".length)
                    if (query.length) {
                        array[2] = query[0][array[2]]
                    }
                } else if (index == 0 && element.match(new RegExp(`.*_fixo$`, 'g'))) {
                    element = getNomeCampo(element)
                    array[0] = element.substring(0, element.length - "_fixo".length)
                }
            });
            return array
        }

        if (dataSet.usaGroupBy) {
            groupBy = dataSet.select.filter(s => s.funcao == 'agrupador').map(s => {
                return getNomeCampo(s.campo)
            })
        }
        if (Array.isArray(groupBy) && groupBy.length === 0) {
            groupBy = null //array vazio não funciona
        }

        if (unico) {
            //se é sobre uma fonte de dados
            let F1 = fontesDados.find(f => f.id == dataSet.id)
            if (F1) {
                dadosF1 = F1.dadosFiltrados || F1.dados
                if (dataSet.where) {
                    let dsWhere = this.vue.$vistra.modificaBetween(dataSet.where)
                    dadosF1 = dadosF1.filter(linha => Query([linha]).filter(processaCamposRelativos(dsWhere, [linha])).toArray().length)
                }
            }
        } else {
            //se é junção de dois datasets
            if (fontesDados.length > 0)
                dadosF1 = fontesDados[0].dadosFiltrados || fontesDados[0].dados
            if (fontesDados.length > 1)
                dadosF2 = fontesDados[1].dadosFiltrados || fontesDados[1].dados
        }

        dataSet.orderBy.filter(obj => obj.campo && obj.direcao).forEach(obj => {
            orderBy.push(getNomeCampo(obj.campo))
            orderBy.push(`|${obj.direcao}|`)
        })

        var obj = {}

        const tipoSelect = dataSet.selectDistinct ? "SelectDistinct" : "Select"
        obj[tipoSelect] = fillSelect(dataSet.select, (unico && !final), unico)

        if (!fazGroupByDepois) {
            if (dataSet.usaGroupBy && (groupBy || []).length > 0) {
                obj.GroupBy = groupBy
            }
            if (dataSet.usaOrderBy && orderBy.length > 0) {
                obj.OrderBy = orderBy
            }
        }

        let dados = [], tudoVazio = false

        if (unico) {
            // sem função (somente um dataset de uma fonte de dados)
            obj.From = dadosF1
            tudoVazio = !dadosF1 || !dadosF1.length
        } else if (dataSet.funcao.includes('Join')) {
            // qualquer join            

            let on = dataSet.on.map(o => {
                if (dadosF1.length && this.checkTipoCampo(dadosF1[0][o.campo1.toLowerCase()]) == 'DATETIME')
                    return `( JSON.stringify(this.f1.${o.campo1.toLowerCase()}) == JSON.stringify(this.f2.${o.campo2.toLowerCase()}) )`
                else
                    return `( this.f1.${o.campo1.toLowerCase()} == this.f2.${o.campo2.toLowerCase()} )`
            })
            var funcaoEval = new Function("return " + on.join(" && "))
            obj.On = funcaoEval

            // se for join (exceto full join) e o primeiro dataset estiver vazio, dá erro. Então deve inverter os datasets
            if (dadosF1.length === 0 && dadosF2.length > 0) {
                obj.From = {f2: dadosF2}
                obj[dataSet.funcao] = {f1: dadosF1}
            } else {
                obj.From = {f1: dadosF1}
                obj[dataSet.funcao] = {f2: dadosF2}
            }
            tudoVazio = (!dadosF1 || !dadosF1.length) && (!dadosF2 || !dadosF2.length)
            if (!tudoVazio && !fazGroupByDepois) {
                if (dataSet.where) {
                    // select precisa ser * pra poder usar where em campos que não foram selecionados
                    obj[tipoSelect] = ["*"]
                    dados = sqllike.q(obj)
                    let dsWhere = this.vue.$vistra.modificaBetween(dataSet.where)
                    dados = dados.filter(linha => Query([linha]).filter(processaCamposRelativos(dsWhere, [linha])).toArray().length)
                    obj = {
                        From: dados
                    }
                }
                obj[tipoSelect] = fillSelect(dataSet.select, true, false)
            }
        } else {
            // union, intersect e except
            let select1 = [], select2 = []
            dataSet.on.forEach((item) => {
                if (!!item.campo1 && !!item.campo2) {
                    select1.push(item.campo1)
                    if (item.campo1 == item.campo2) {
                        select2.push(item.campo2)
                    } else {
                        select2.push(item.campo2)
                        select2.push("|as|")
                        select2.push(item.campo1.toLowerCase())
                    }
                } else {
                    if (!!item.campo1) {
                        let campo1 = `${item.campo1}_1`
                        select1.push(item.campo1)
                        select1.push("|as|")
                        select1.push(campo1.toLowerCase())
                        select2.push(campo1)
                        select2.push("|as|")
                        select2.push(campo1.toLowerCase())
                    } else {
                        let campo2 = `${item.campo2}_2`
                        select2.push(item.campo2)
                        select2.push("|as|")
                        select2.push(campo2.toLowerCase())
                        select1.push(campo2)
                        select1.push("|as|")
                        select1.push(campo2.toLowerCase())
                    }
                }
            })

            obj = {}
            obj[dataSet.funcao] = [
                {
                    Select: select1,
                    From: dadosF1
                },
                {
                    Select: select2,
                    From: dadosF2
                }
            ]
            tudoVazio = (!dadosF1 || !dadosF1.length) && (!dadosF2 || !dadosF2.length)

            if (!fazGroupByDepois && !tudoVazio) {
                dados = sqllike.q(obj)
                if (dataSet.where) {
                    let dsWhere = this.vue.$vistra.modificaBetween(dataSet.where)
                    dados = dados.filter(linha => Query([linha]).filter(processaCamposRelativos(dsWhere, [linha])).toArray().length)
                }
                obj = {
                    Select: fillSelect(dataSet.select, true, false),
                    From: dados
                }
                if (dataSet.usaOrderBy && orderBy.length > 0) {
                    obj.OrderBy = orderBy
                }
            }
        }

        if (!tudoVazio) {
            dados = sqllike.q(obj)
            if (fazGroupByDepois) {
                // tem q executar novamente somente com o group by pq não funciona o group by usando função com duas fontes
                if (dataSet.where) {
                    let dsWhere = this.vue.$vistra.modificaBetween(dataSet.where)
                    dados = dados.filter(linha => Query([linha]).filter(processaCamposRelativos(dsWhere, [linha])).toArray().length)
                }

                obj = {
                    Select: fillSelect(dataSet.select, true, true),
                    From: dados,
                    GroupBy: groupBy
                }
                if (dataSet.usaOrderBy && orderBy.length > 0) {
                    obj.OrderBy = orderBy
                }
                dados = sqllike.q(obj)
            }
            if (dataSet.usaGroupBy && dataSet.having) {
                let dsHaving = this.vue.$vistra.modificaBetween(dataSet.having)
                dados = dados.filter(linha => Query([linha]).filter(processaCamposRelativos(dsHaving, [linha])).toArray().length)
            }
        }

        var getTipoCampo = (campo) => {
            let isUnionOrExcept = false
            let idxCampo = 2;
            let idDataset = 0;

            var aux = campo.match(/F?(\d).(.*)/) || campo.match(/f?(\d).(.*)/)

            if (aux === null && !!campo.match(/(.*)(_)(\d)/)) {
                aux = campo.match(/(.*)(_)(\d)/)
                isUnionOrExcept = true // union, except
                idxCampo = 1
                idDataset = (aux[3] - 1)
            }

            let fd = fontesDados.find(fd => fd.id == (unico ? dataSet.id : dataSet.fonteDados[aux ? (isUnionOrExcept ? idDataset : aux[1] - 1) : 0]?.id))
            if (fd) {
                let campoFD = fd.campos.find(c => (c.campo.toLowerCase() == campo.toLowerCase()) || (aux && (aux[idxCampo].toLowerCase() == c.campo.toLowerCase())))
                if (campoFD)
                    return campoFD.tipo
            }
            if (dados.length > 0)
                return this.checkTipoCampo(dados[0][campo])
            return 'VARYING'
        }

        let nomesCampos = []
        let campos = []
        let fd = fontesDados.find(fd => fd.id == dataSet.idFonteDados)
        let camposFD = fd ? fd.campos : []

        dataSet.select.forEach(s => {
            let campo = s.novoNome
            if (!campo) {
                campo = getNomeCampo(s.campo)
            }
            nomesCampos.push(campo)

            //Coloca nos {dados} o novo nome do campo.
            //Apenas quando tiver 1 só fonte, pois quando tem duas, os {dados} vêm pronto.
            if (!dadosF2.length) {
                dados.forEach(linha => {
                    Object.keys(linha).forEach(chave => {
                        //Somente se tiver novo nome
                        if (chave === s.campo && s.novoNome) {
                            // Adiciona o novo nome nos {dados} e apaga o antigo.
                            linha[campo] = linha[chave];
                            delete linha[chave];
                        }
                    })
                })
            }

            let tipo = (s.funcao == "count") ? 'INTEGER' : getTipoCampo(campo)

            campos.push({
                campo: campo,
                titulo: campo,
                tipo: tipo,
                campoFuncao: false,
                idFonteDados: fd ? fd.id : 0,
                formatacao: this.vue.$vistra.Tipos.getTipoFormatacao(tipo)
            })

            if (dataSet.idFonteDados) {
                let campoFD = camposFD.find(c => c.campo === campo)
                if (!campoFD) {
                    camposFD.push(campos[campos.length - 1])
                } else {
                    //atualiza o tipo           
                    campoFD.tipo = tipo;
                }
            }
        })

        if (dataSet.idFonteDados) {
            //remove os campos que não existem mais
            camposFD = camposFD.filter((c) => {
                return c.campoFuncao || nomesCampos.indexOf(c.campo) !== -1
            })
            campos = camposFD
        }

        return {
            dados,
            campos
        }
    }

    carregaFontesDadosCalculadas(fontesDados) {
        fontesDados.filter(f => [0, 2, 3, 4].includes(f.tipo) && !f.infoExecucao.executando).forEach((fonteDados) => {
            if (fonteDados.tipo === 0) {
                //this.compilaConsultaSQLSobreOutrasFontes(fonteDados, fontesDados)
                console.warning("Fonte de dados tipo SQL sobre outras fontes ainda sendo utilizado!", fonteDados.alias)
            } else if ((fonteDados.tipo === 2) && !fonteDados.infoExecucao.status) {
                this.compilaDataSets(fonteDados, fontesDados)
            } else if (fonteDados.tipo === 4 && !fonteDados.infoExecucao.status) {
                this.compilaDataSetSqlQuery(fonteDados, fontesDados)
            }
        })
    }

    carregaPacote = async function (fonteDadosGeral, hash, idPacote, nroPacotes, executionKey) {
        let _this = this;

        if (!fonteDadosGeral.fonteDados.infoExecucao.nroPacotes || fonteDadosGeral.fonteDados.infoExecucao.nroPacotes < nroPacotes)
            fonteDadosGeral.fonteDados.infoExecucao.nroPacotes = nroPacotes

        if (this.progressoExecucao) {
            this.progressoExecucao()
        }

        let finalizaFonte = async () => { // todo tirar de dentro do carrega pacote
            fonteDadosGeral?.conexaoSignalR?.stop()


            if (fonteDadosGeral.fonteDados.metricasFonteDados){
                fonteDadosGeral.fonteDados.metricasFonteDados.tempoFinalizacao = (Date.now() - fonteDadosGeral.fonteDados.metricasFonteDados.dataInicioExecucao)
                fonteDadosGeral.fonteDados.infoExecucao.metricas = JSON.stringify(fonteDadosGeral.fonteDados.metricasFonteDados, null, 2)
            }

            let dados = fonteDadosGeral.arrayPacotes.reduce((acc, f) => acc.concat(f.dados), [])
            fonteDadosGeral.fonteDados.dados = markRaw(dados)

            fonteDadosGeral.arrayPacotes = []
            _this.calculaCamposFuncao(fonteDadosGeral.fonteDados)
            _this.criaCamposClonados(fonteDadosGeral.fonteDados)
            _this.setAsBaixado(fonteDadosGeral.fonteDados)


            if (_this.fonteDadosConcluida) {
                fonteDadosGeral.fonteDados.infoExecucao.tempoTotal = (Date.now() - fonteDadosGeral.fonteDados.auxTempo.inicioTotal)
                await _this.fonteDadosConcluida(fonteDadosGeral.fonteDados.idUnico)
                _this.statusFonteDadosExecutada(fonteDadosGeral)
            }
            if (fonteDadosGeral.fonteDados.infoExecucao.nroPacotes === 0 && _this.progressoDownload) {
                fonteDadosGeral.fonteDados.infoExecucao.tempoTotal = (Date.now() - fonteDadosGeral.fonteDados.auxTempo.inicioTotal)
                _this.progressoDownload()
            }
        }

        const iniciaPacote = async () => { // todo tirar de dentro do carrega pacote
            fonteDadosGeral.fonteDados.auxTempo.pacotesEmDownload = fonteDadosGeral.fonteDados.auxTempo.pacotesEmDownload.filter(p => p !== idPacote);
            if (fonteDadosGeral.fonteDados.auxTempo.pacotesEmDownload.length == 0) {
                fonteDadosGeral.fonteDados.infoExecucao.tempoDownload += (Date.now() - fonteDadosGeral.fonteDados.auxTempo.inicioDownload)
                fonteDadosGeral.fonteDados.auxTempo.inicioDownload = null;
            }

            fonteDadosGeral.fonteDados.auxTempo.pacotesEmPreparacao.push(idPacote)
            if (!fonteDadosGeral.fonteDados.auxTempo.inicioPreparacao)
                fonteDadosGeral.fonteDados.auxTempo.inicioPreparacao = Date.now();
        }

        if (!fonteDadosGeral.fonteDados.auxTempo) {
            fonteDadosGeral.fonteDados.infoExecucao.executando = true
            fonteDadosGeral.fonteDados.auxTempo = new AuxTempo()
        }
        let url = "";

        if (fonteDadosGeral.fonteDados.tipo == 0) //SQL
            url = `/DataSourceExecution/DownloadDataSourcePackage?packageId=${idPacote}&executionKey=${executionKey ?? fonteDadosGeral.fonteDados.infoExecucao.executionKey}`

        if (fonteDadosGeral.fonteDados.tipo == 3) //REQUISICAO API
            url = `/RequisicaoAPI/GetArquivoDados?idRequisicaoApi=${fonteDadosGeral.fonteDados.idRequisicaoAPI}&hash=${hash}&desenvolvimento=${this.desenvolvimento}&signalRConnectionId=${fonteDadosGeral.connectionId}`

        if (fonteDadosGeral.idExecucaoSnapshot)
            url = `/Snapshot/GetArquivo/${fonteDadosGeral.idExecucaoSnapshot}/${fonteDadosGeral.idSnapshot}/${fonteDadosGeral.fonteDados.id}/${idPacote}`


        let metricasPacote = new MetricasPacote(idPacote)
        try {
            let responseArq = await this.vue.$http({
                method: 'get',
                url: url,
                responseType: 'blob',
            })

            metricasPacote.tempoDownload = (Date.now() - metricasPacote.dataInicioDownload)
            metricasPacote.dataInicioSerializacao = Date.now()

            await iniciaPacote()

            let jsZip = new JSZip();
            let arquivoZip = await jsZip.loadAsync(new Blob([responseArq.data], {type: responseArq.data.type}))

            let nroArquivosCompactados = Object.keys(arquivoZip.files).length;
            let indiceArquivo = 0;
            let dadosExecucaoArq = [];

            let descompactaArquivo = async () => {
                let dadosArq = await arquivoZip.files[Object.keys(arquivoZip.files)[indiceArquivo]].async("string")

                //JSON.dateParser deixa mais lento mas é necessário quando tem campo tipo data e o valor vem como texto
                if (fonteDadosGeral.fonteDados.campos.find(c => ['DATETIME', 'DATE'].includes(c.tipo)))
                    dadosExecucaoArq = dadosExecucaoArq.concat(JSON.parse(dadosArq, JSON.dateParser))
                else
                    dadosExecucaoArq = dadosExecucaoArq.concat(JSON.parse(dadosArq))

                indiceArquivo++;
                if (indiceArquivo !== nroArquivosCompactados)
                    return await descompactaArquivo();

                if (fonteDadosGeral.fonteDados.metricasFonteDados){
                    metricasPacote.tempoSerializacao = (Date.now() - metricasPacote.dataInicioSerializacao)
                    fonteDadosGeral.fonteDados.metricasFonteDados.pacotes.push(metricasPacote)
                }

                await finalizaPacote()
            }

            let finalizaPacote = async () => {
                let indiceAux = idPacote - 1;
                fonteDadosGeral.arrayPacotes[indiceAux].dados = dadosExecucaoArq;
                fonteDadosGeral.arrayPacotes[indiceAux].status = "baixado"

                let todosPacotesBaixados = fonteDadosGeral.arrayPacotes.filter(a => a.status === "baixado").length === fonteDadosGeral.arrayPacotes.length
                if (fonteDadosGeral.fonteDados.infoExecucao.ultimoPronto && todosPacotesBaixados)
                    await finalizaFonte();

                fonteDadosGeral.fonteDados.auxTempo.pacotesEmPreparacao = fonteDadosGeral.fonteDados.auxTempo.pacotesEmPreparacao.filter(p => p !== idPacote);
                if (fonteDadosGeral.fonteDados.auxTempo.pacotesEmPreparacao.length == 0) {
                    fonteDadosGeral.fonteDados.infoExecucao.tempoPreparacao += (Date.now() - fonteDadosGeral.fonteDados.auxTempo.inicioPreparacao)
                    fonteDadosGeral.fonteDados.auxTempo.inicioPreparacao = null;
                }

                if (_this.progressoDownload)
                    _this.progressoDownload()
            };

            await descompactaArquivo();

        }
        catch (error) {
            this.vue.$vistra.showMessage(!error.data ? error.message : error.data.msgErro, "error")
        }
    }

    async executaFonteDados(fonteDados, forcarAtualizarUltimaConexao = false) {
        fonteDados.ultimaAtt = Date.now();
        fonteDados.infoExecucao.executando = true

        fonteDados.infoExecucao.tempoExecucao = 0;
        fonteDados.infoExecucao.tempoSerializacao = 0;
        fonteDados.infoExecucao.tempoDownload = 0;
        fonteDados.infoExecucao.tempoPreparacao = 0;
        fonteDados.infoExecucao.tempoTotal = 0;

        fonteDados.auxTempo = {}
        fonteDados.auxTempo.inicioDownload = null;
        fonteDados.auxTempo.inicioPreparacao = null;
        fonteDados.auxTempo.inicioTotal = null;
        fonteDados.auxTempo.pacotesEmDownload = [];
        fonteDados.auxTempo.pacotesEmPreparacao = [];

        fonteDados.dados = [];

        let fonteDadosGeral = {
            fonteDados: fonteDados,
            conexaoSignalR: new signalR.HubConnectionBuilder()
                .withUrl(`${getBack(process.env.NODE_ENV)}/hub-execucaosqlhub`)
                .withAutomaticReconnect()
                .withServerTimeout(90000 + 15000)
                .build()
        }

        this.fontesDadosGeral.push(fonteDadosGeral)
        this.onInfoExecucaoConsultaSQL(fonteDadosGeral)
        this.onPacotePronto(fonteDadosGeral)
        this.onConnectionId(fonteDadosGeral, forcarAtualizarUltimaConexao);
        this.startConexaoSignalR(fonteDadosGeral)
        fonteDados.infoExecucao.executando = false
    }

    startConexaoSignalR(fonteDadosGeral) {
        if (!fonteDadosGeral?.conexaoSignalR)
            return

        fonteDadosGeral.conexaoSignalR
            .start()
            .catch((err) => {
                    let tempoPraTentarReconnect = 10000
                    if (this.tempoTentando < 10000) {
                        tempoPraTentarReconnect = 500;
                    } else if (this.tempoTentando < 30000) {
                        tempoPraTentarReconnect = 3000;
                    }

                    setTimeout(() => {
                        this.tempoTentando += tempoPraTentarReconnect
                        this.startConexaoSignalR()
                    }, tempoPraTentarReconnect)
                }
            );
    }

    pacoteProntoSnapshot(fonteDadosGeral, idPacote, nroPacotes) {
        if (idPacote === nroPacotes) //último pacote
            fonteDadosGeral.fonteDados.infoExecucao.ultimoPronto = true
        if (!fonteDadosGeral.arrayPacotes)
            fonteDadosGeral.arrayPacotes = new Array(nroPacotes)
        else if (fonteDadosGeral.arrayPacotes.length < nroPacotes) //só pra garantir
            fonteDadosGeral.arrayPacotes = fonteDadosGeral.arrayPacotes.concat(new Array(nroPacotes - fonteDadosGeral.arrayPacotes.length))

        if (idPacote > 0) {
            fonteDadosGeral.arrayPacotes[idPacote - 1] = {
                idPacote: idPacote,
                status: "pronto",
                dados: []
            }
            this.carregaPacote(fonteDadosGeral, "", idPacote, nroPacotes, Date.now())
        } else {
            this.setAsBaixado(fonteDadosGeral.fonteDados)

            if (this.progressoExecucao)
                this.progressoExecucao();
            if (this.progressoDownload)
                this.progressoDownload()
        }
    }

    statusFonteDadosExecutada(fonteDadosGeral) {
        fonteDadosGeral.fonteDados.ultimaAtt = Date.now();

        if (this.painel && this.painel.editor && !this.painel.isSnapshot) {
            let arAtt = this.painel.fonteDadosAtualizacaoAutomaticas;
            if (!arAtt.find(f => f.idUnico == fonteDadosGeral.fonteDados.idUnico)) {
                if (!fonteDadosGeral.fonteDados.attAutomatica)
                    return;
                console.show(`⏰ ${fonteDadosGeral.fonteDados.alias}: Fonte de dados separada para futura reexecução em ${fonteDadosGeral.fonteDados.attTimer} segundos`);
                arAtt.push(fonteDadosGeral.fonteDados);
            }
        }
    }

    criaCamposClonados(fonteDados) {
        if (!fonteDados?.dados?.length)
            return
        for (const campo of fonteDados.campos.filter(c => c.campoOrigem)) {
            const campoOrigem = Object.keys(fonteDados.dados[0]).find(c => c.toLowerCase() == campo.campoOrigem.toLowerCase()) || campo.campoOrigem
            for (let registro of fonteDados.dados) {
                registro[campo.campo.toLowerCase()] = registro[campoOrigem]
            }
        }
    }

    calculaCamposFuncao(fonteDados) {
        if (fonteDados.campos.find(c => c.campoFuncao)) {
            let resultado = CamposCalculados.calcular(fonteDados.dados, fonteDados.campos)
            if (!resultado.erro) {
                fonteDados.dados = markRaw(resultado.dados)
            }
        }
    }

    onConnectionId(fonteDadosGeral, forcarAtualizarUltimaConexao) {
        let _this = this
        fonteDadosGeral.fonteDados.auxTempo.inicioTotal = Date.now();
        fonteDadosGeral.conexaoSignalR.on("connectionId", async (connectionId) => {
            if (fonteDadosGeral.connectionId) //se já executou com algum id não executa novamente
                return
            fonteDadosGeral.connectionId = connectionId

            fonteDadosGeral.fonteDados.metricasFonteDados = new MetricasFonteDados()

            if (!!_this.parametrosExecucao) {
                _this.parametrosExecucao.seletores.forEach(seletor => {
                    delete seletor.componenteSeletor;
                    delete seletor.componentesSeletor;
                });
                _this.parametrosExecucao.parametrosGlobais.forEach(parametro => {
                    delete parametro._Valor;
                    delete parametro._DescricaoSelecao;
                });
            }

            let config = {
                signalRConnectionId: connectionId,
                fonteDados: {...fonteDadosGeral.fonteDados, dados: [], dadosFiltrados: []},
                parametrosExecucao: _this.parametrosExecucao,
                desenvolvimento: _this.desenvolvimento,
                forcarAtualizarUltimaConexao: forcarAtualizarUltimaConexao,
                gravarParametros: _this.gravarParametros,
                reexecutaSeletores: _this.reexecutaSeletores,
                configuracoesExternasConexoesAPI: _this.painel.configuracoesExternasConexoesAPI
            }

            switch (fonteDadosGeral.fonteDados.tipo) {
                //SQL
                case 0:
                    try {
                        if (fonteDadosGeral.idExecucaoSnapshot){
                            let response = await _this.vue.$http.post("/Painel/ExecutaFonteDados", config);

                            fonteDadosGeral.fonteDados.dataAtualizacaoPainel = response.data.dataAtualizacaoPainel;
                            if (!!response.data.msgErro) {
                                _this.setErro(fonteDadosGeral, response.data.msgErro)
                                console.show("Info Execução: ", response.data)
                            } else {
                                if (response.data.atualizarData) {
                                    let date = new Date(response.data.dataHoraExecucao)
                                    let stringData = _this.vue.$vistra.formatDate(date, "yyyy-MM-dd'T'HH:mm:ss")
                                    fonteDadosGeral.fonteDados.ultimaAtualizacao = stringData
                                }
                            }
                            break;
                        }

                        fonteDadosGeral.fonteDados.metricasFonteDados = new MetricasFonteDados()
                        let startExecutionResponse = await _this.vue.$http
                            .post("/DataSourceExecution/StartDataSourceExecution", config)

                        if (!startExecutionResponse.data){
                            fonteDadosGeral.conexaoSignalR?.stop()

                            fonteDadosGeral.fonteDados.metricasFonteDados.dataFimExecucao = Date.now()

                            fonteDadosGeral.fonteDados.infoExecucao.status = "erro"
                            fonteDadosGeral.fonteDados.infoExecucao.executando = false

                            if (this.progressoExecucao) this.progressoExecucao()
                            if (this.progressoDownload) this.progressoDownload()
                        }

                        fonteDadosGeral.fonteDados.infoExecucao.executionKey = startExecutionResponse.data;
                    }
                    catch (error) {
                        _this.setErro(fonteDadosGeral, error.data.detail)
                    }
                    break;
                //API
                case 3:
                    await _this.servicesExecucaoRequisicaoAPI.executarRequisicaoAPI(config);
                    fonteDadosGeral.fonteDados.ultimaAtualizacao = _this.vue.$vistra.formatDate(new Date(), "yyyy-MM-dd'T'HH:mm:ss")
                    break;
            }

        });
    }

    setErro(fonteDadosGeral, msgErro) {
        this.vue.$vistra.showMessage(msgErro, "error")
        console.error("=====>>> erro fonte", fonteDadosGeral.fonteDados.idUnico, "tipo", fonteDadosGeral.fonteDados.tipo)

        fonteDadosGeral.conexaoSignalR?.stop()

        fonteDadosGeral.fonteDados.metricasFonteDados.dataFimExecucao = Date.now()

        fonteDadosGeral.fonteDados.infoExecucao.status = "erro"
        fonteDadosGeral.fonteDados.infoExecucao.executando = false
        fonteDadosGeral.fonteDados.infoExecucao.msgErro = msgErro

        if (this.progressoExecucao) this.progressoExecucao()
        if (this.progressoDownload) this.progressoDownload()
    }

    onInfoExecucaoConsultaSQL(fonteDadosGeral) {
        let _this = this
        fonteDadosGeral.conexaoSignalR.on("infoExecucaoConsultaSQL", function (infoExecucaoConsultaSQL) {
            if (infoExecucaoConsultaSQL.msgErro){
                _this.setErro(fonteDadosGeral, infoExecucaoConsultaSQL.msgErro)
                return
            }

            if (infoExecucaoConsultaSQL.nroPacotes === 0
                && infoExecucaoConsultaSQL.ultimoPronto){
                fonteDadosGeral.conexaoSignalR?.stop()
                fonteDadosGeral.fonteDados.infoExecucao.executando = false
                fonteDadosGeral.fonteDados.infoExecucao.ultimoPronto = true

                if (fonteDadosGeral.fonteDados.metricasFonteDados){
                    fonteDadosGeral.fonteDados.metricasFonteDados.dataFimExecucao = Date.now()
                    fonteDadosGeral.fonteDados.metricasFonteDados.tempoAteUltimoPronto
                        = (Date.now() - fonteDadosGeral.fonteDados.metricasFonteDados.dataInicioExecucao)
                }

                _this.setAsBaixado(fonteDadosGeral.fonteDados)
                if (_this.progressoExecucao) _this.progressoExecucao()
                if (_this.progressoDownload) _this.progressoDownload()
                if (_this.fonteDadosConcluida) _this.fonteDadosConcluida(fonteDadosGeral.fonteDados.idUnico)
            }

            for (let prop in infoExecucaoConsultaSQL)
                fonteDadosGeral.fonteDados.infoExecucao[prop] = infoExecucaoConsultaSQL[prop]
        });
    }

    onPacotePronto(fonteDadosGeral) {
        let _this = this;
        fonteDadosGeral.conexaoSignalR.on("pacotePronto", (hash, idPacote, nroPacotes, ultimoPacote, executionKey) => {

            fonteDadosGeral.fonteDados.auxTempo.pacotesEmDownload.push(idPacote)
            if (!fonteDadosGeral.fonteDados.auxTempo.inicioDownload)
                fonteDadosGeral.fonteDados.auxTempo.inicioDownload = Date.now();

            if (ultimoPacote){
                fonteDadosGeral.fonteDados.infoExecucao.ultimoPronto = true

                if (fonteDadosGeral.fonteDados.metricasFonteDados)
                    fonteDadosGeral.fonteDados.metricasFonteDados.tempoAteUltimoPronto = (Date.now() - fonteDadosGeral.fonteDados.metricasFonteDados.dataInicioExecucao)
            }
            if (nroPacotes < idPacote)
                nroPacotes = idPacote
            if (!fonteDadosGeral.arrayPacotes)
                fonteDadosGeral.arrayPacotes = new Array(nroPacotes)
            else if (fonteDadosGeral.arrayPacotes.length < nroPacotes)
                fonteDadosGeral.arrayPacotes = fonteDadosGeral.arrayPacotes.concat(new Array(nroPacotes - fonteDadosGeral.arrayPacotes.length))

            if (idPacote > 0) {
                fonteDadosGeral.arrayPacotes[idPacote - 1] = {
                    idPacote: idPacote,
                    status: "pronto",
                    dados: []
                }
                _this.carregaPacote(fonteDadosGeral, hash, idPacote, nroPacotes, executionKey)
            } else {
                _this.setAsBaixado(fonteDadosGeral.fonteDados)
                if (_this.progressoExecucao)
                    _this.progressoExecucao();
                if (_this.progressoDownload)
                    _this.progressoDownload()
                if (_this.fonteDadosConcluida)
                    _this.fonteDadosConcluida(fonteDadosGeral.fonteDados.idUnico)
            }
        });
    }

    setAsBaixado(fonteDados) {
        fonteDados.infoExecucao.status = "baixado";

        fonteDados.infoExecucao.memoria = 0

        if (!!fonteDados.dados) {
            fonteDados.infoExecucao.linhas = fonteDados.dados?.length ? fonteDados.dados.length : 0;
            fonteDados.infoExecucao.colunas = fonteDados.dados?.length ? Object.keys(fonteDados.dados[0]).length : 0;
        }

        // timeout necessário para atualizar o valor de variaveis que usam a fonte     
        setTimeout(() => {
            fonteDados.infoExecucao.executando = false;
            this.vue.$store.commit('setFonteDadosExecutada', fonteDados.idUnico);
        }, 50);
    }
    forjaExecucao(fonteDados, dados) {
        fonteDados.infoExecucao.executando = true
        fonteDados.dados = markRaw(dados)
        this.setAsBaixado(fonteDados)
        setTimeout(() => {
            if (this.progressoDownload)
                this.progressoDownload()
            if (this.fonteDadosConcluida)
                this.fonteDadosConcluida(fonteDados.idUnico)
        }, 60);
    }
}

